import React, {useEffect} from "react";
import { Route, Routes } from "react-router-dom";
import Textures from "../layout/texture/Textures";
import AddTextures from "../layout/texture/AddTextures";
const TexturesPage = () => {
    useEffect(() => {
        return() =>{
            localStorage.removeItem("selectedId")
            localStorage.removeItem("itemOffset")
            localStorage.removeItem("forcePage")
        }
    }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Textures />} />
        <Route path="/add" element={<AddTextures />} />
        <Route path="/update/:id" element={<AddTextures />} />
      </Routes>
    </>
  );
};

export default TexturesPage;
